import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/uber/posIntegration';

const getToken = (code, redirectUri) => {
	return Client.get(`${baseUrl}/token`, {
		code,
		redirectUri,
	});
};

// TODO: Optimise
const branchStatus = (merchantId, branchId, companyCode) => {
	return Client.get(
		`/gateway/eagle-mgt/api/vs/manage-cooperation/${merchantId}/onlineCooperationCompanyRelations`,
		{ branchId, companyCode }
	);
	// return Client.get(`${baseUrl}/${merchantId}/${branchId}/pos_data`);
};

const stores = (posProvisioningToken, limit, startKey) => {
	return Client.get(`${baseUrl}/stores`, {
		posProvisioningToken,
		startKey,
		limit,
	});
};

const bind = (
	merchantId,
	branchId,
	uberStoreId,
	uberStoreName,
	posIntegrationEnabled,
	posProvisioningToken,
	operateBy
) => {
	return Client.post(`${baseUrl}/${merchantId}/pos_data`, {
		branchId,
		uberStoreId,
		uberStoreName,
		posIntegrationEnabled,
		posProvisioningToken,
		operateBy,
	});
};

const unbind = (
	merchantId,
	branchId,
	uberStoreId,
	posProvisioningToken,
	operateBy
) => {
	return Client.post(`${baseUrl}/${merchantId}/pos_data/remove`, {
		branchId,
		uberStoreId,
		posProvisioningToken,
		operateBy,
	});
};

export default {
	getToken,
	branchStatus,
	stores,
	bind,
	unbind,
};
